function format(val,fmt) {
	// console.log(val, fmt);
	var o = {
		"M+": val.getMonth() + 1, //月份 
		"d+": val.getDate(), //日 
		"h+": val.getHours(), //小时 
		"m+": val.getMinutes(), //分 
		"s+": val.getSeconds(), //秒 
		"q+": Math.floor((val.getMonth() + 3) / 3), //季度 
		"S": val.getMilliseconds() //毫秒 
	};
	if(/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (val.getFullYear() + "").substr(4 - RegExp.$1.length));
	for(var k in o)
		if(new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}

export function dateFormat(val, fmt) {
	var temp = val.split(" ");
	var o = {
		"y+": temp[0].substring(0, 4),
		"M+": temp[0].substring(5, 7),
		"d+": temp[0].substring(8, 10),
		"h+": temp[1].substring(0, 2),
		"m+": temp[1].substring(3, 5),
		"s+": temp[1].substring(6, 8),
	}
	if(/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (temp[0].substring(0, 4) + "").substr(4 - RegExp.$1.length));
	for(var k in o)
		if(new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt
}

export default format


// WEBPACK FOOTER //
// core-build-local/filters/date/format.js